export function enumToArray(enumObject) {
    return Object.values(enumObject);
}
